<template>
  <div>
    <spinner v-if="loading"></spinner>
    <vue-good-table v-else
                    :columns="columns"
                    :rows="rows"
                    :pagination-options="{'enabled': true}">
      <div slot="emptystate">
        No forms available.
      </div>
      <template slot="table-row" slot-scope="props">
        <div v-if="props.column.field ==='name'" class="highlight">
          <div class="warning"></div>
          {{ props.row.name }}
        </div>
        <span v-else-if="props.column.field ==='type'" class="capitalize">{{ props.row.type }}</span>
        <span v-else-if="props.column.field === 'publish'">
          <span class="label label-sm"
                :class="[props.row.publish === 'Published' ? 'label-warning' : 'label-danger']">
            {{ props.row.publish }}
          </span>
        </span>
        <template v-else-if="props.column.field ==='actions'">

          <div class="last-dropdown">
            <actions-menu>
              <actions-menu-item
                title="Edit"
                icon="fa-edit"
                :to="{ name: 'Form Builder Edit', params: { id: props.row.id } }"
              />
              <actions-menu-item
                v-if="!isTemplate"
                title="Export PDF"
                icon="fa-file-pdf-o"
                @click.prevent="exportPDF(props.row.id)"
              />
              <actions-menu-item
                v-if="!isTemplate"
                title="Duplicate"
                icon="fa-files-o"
                @click.prevent="duplicateForm(props.row.id)"
              />
              <actions-menu-item
                title="Remove"
                icon="fa-trash"
                @click.prevent="removeForm(props.row.id)"
              />
              <actions-menu-item
                v-if="showShareUrl"
                title="Copy link to the form"
                icon="fa-link"
                @click.prevent="copyLink(props.row.shareUrl, $event.target)"
              />
            </actions-menu>
          </div>

        </template>
        <span v-else>{{ props.formattedRow[props.column.field] }}</span>
      </template>
    </vue-good-table>

    <duplicate-form-modal v-if="showDuplicateFormModal"
                          v-on:hide="showDuplicateFormModal = false"
                          v-on:duplicate-success="formDuplicated"
                          :duplicateFormId="formId"/>

    <remove-form-modal v-if="showRemoveFormModal"
                       :form-id="formId"
                       v-on:form-removed="$emit('form-removed', formId)"
                       v-on:display="showRemoveFormModal = $event"
    >
    </remove-form-modal>
  </div>
</template>

<script>
import FileSaver from "file-saver";
import {HTTP} from '@/http-common';

import ActionsMenu from "../../reusables/ActionsMenu";
import ActionsMenuItem from "../../reusables/ActionsMenuItem";
import DuplicateFormModal from "@/components/formbuilder/modals/DuplicateFormModal";
import RemoveFormModal from '@/components/formbuilder/modals/RemoveFormModal';
import Spinner from "../../Spinner";

export default {
  components: {
    ActionsMenu,
    ActionsMenuItem,
    DuplicateFormModal,
    RemoveFormModal,
    Spinner,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    isTemplate: {
      type: Boolean,
      default: false,
    },
    showShareUrl: {
      type: Boolean,
      default: false,
    },
    columns: {
      type: Array,
      required: true,
    },
    rows: {
      type: Array,
      required: true,
    }
  },
  emits: ['form-removed'],
  data() {
    return {
      showRemoveFormModal: false,
      showDuplicateFormModal: false,
      formId: null,
    }
  },
  methods: {
    duplicateForm(formId) {
      this.formId = formId;
      this.showDuplicateFormModal = true;
    },
    removeForm(formId) {
      this.formId = formId;
      this.showRemoveFormModal = true;
    },
    exportPDF(formId) {
      HTTP.get('/form/pdf/' + formId)
        .then(response => {
          if (response.status === 200) {
            let byteCharacters = atob(response.data);
            let byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            let byteArray = new Uint8Array(byteNumbers);
            let blob = new Blob([byteArray], {type: "application/pdf"});
            FileSaver.saveAs(blob, 'FormPDF_' + formId + '.pdf');
          }
        })
        .catch(error => {
          console.log(error);
        })
    },
    formDuplicated(newFormId) {
      this.$router.push({name: 'Form Builder Edit', params: {id: newFormId}});
    },
    copyLink(url) {
      try {
        navigator.clipboard.writeText(url).then(() => {
          this.$notify('Copied to clipboard')
        }, () => {
          this.$notify({type: 'error', text: 'Copying to clipboard failed!'})
        });
      } catch (e) {
        this.$notify({type: 'error', text: 'Copying to clipboard failed!'})
      }
    }
  }
}
</script>

<style scoped lang="scss">
.share-url-input {
  display: none;
}
</style>



// WEBPACK FOOTER //
// BaseFormIndex.vue?df5bbf00